var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.746 34.5051C151.64 15.51 137.094 25.0137 108.397 41.2776C79.7006 57.5415 46.0358 61.1502 26.5834 104.961C7.13095 148.773 77.8962 254.488 162.985 225.124C248.074 195.76 245.54 72.8538 182.746 34.5051Z",
    fill: "#E9F2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.001 49.694C145.438 49.694 147.413 47.7187 147.413 45.282C147.413 42.8453 145.438 40.87 143.001 40.87C140.564 40.87 138.589 42.8453 138.589 45.282C138.589 47.7187 140.564 49.694 143.001 49.694Z",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.147 146.19H244.923",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240.041 141.296V151.084",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.232 204.905H116.233",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.226 198.911V210.899",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.713 141.555V75.9558C114.713 70.4933 119.137 66.069 124.599 66.069H183.735C189.198 66.069 193.622 70.4933 193.622 75.9558V145.189V155.1V166.136V175.776C193.622 176.765 193.276 177.716 192.671 178.421L186.355 183.797L178.236 177.333L170.067 183.846L161.898 177.346L153.766 183.834L145.683 177.346L137.7 183.76L129.728 177.346L121.831 183.698L115.652 178.433C115.046 177.729 114.7 176.79 114.7 175.801V140.319",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.622 166.149V175.789C193.622 176.777 193.276 177.729 192.67 178.433L187.9 182.499C186.998 183.266 185.688 183.29 184.761 182.549L179.768 178.582C178.866 177.865 177.593 177.865 176.691 178.582L171.599 182.635C170.697 183.352 169.424 183.352 168.522 182.635L163.455 178.594C162.553 177.877 161.267 177.877 160.365 178.594L155.323 182.623C154.421 183.34 153.135 183.34 152.233 182.623L147.24 178.606C146.338 177.877 145.053 177.877 144.151 178.606L139.257 182.536C138.354 183.266 137.069 183.266 136.155 182.536L131.285 178.619C130.383 177.89 129.086 177.89 128.183 178.619L123.438 182.437C122.511 183.179 121.188 183.167 120.286 182.388L115.676 178.446C115.071 177.741 114.725 176.802 114.725 175.813V140.332",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.712 141.555V75.9558C114.712 70.4933 119.137 66.069 124.599 66.069H183.735C189.198 66.069 193.622 70.4933 193.622 75.9558V145.189",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.887 133.93H182.129",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.887 146.919H182.129",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.226 159.908H182.128",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.887 159.908H156.88",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2473 147.166L53.3397 105.864C51.4364 101.477 53.4509 96.3848 57.8382 94.4816L93.4309 79.0457C97.8182 77.1425 102.91 79.1569 104.813 83.5442L123.759 127.22L126.564 133.683L129.691 140.888L132.422 147.179C132.707 147.821 132.744 148.538 132.546 149.168L129.951 154.47L122.82 152.555L119.322 159.117L112.167 157.177L108.706 163.714L101.6 161.762L98.2013 168.201L91.194 166.273L87.8448 172.65L82.3329 170.957C81.7397 170.672 81.2454 170.153 80.9735 169.511L70.9383 146.363",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.895 128.06L132.546 148.019C132.83 148.662 132.867 149.378 132.669 150.009L130.519 154.396C130.26 154.927 129.654 155.199 129.085 155.051L123.895 153.654C123.339 153.506 122.758 153.753 122.486 154.272L119.915 159.092C119.644 159.599 119.063 159.858 118.507 159.71L113.254 158.289C112.698 158.141 112.105 158.388 111.833 158.907L109.299 163.69C109.027 164.196 108.434 164.456 107.878 164.308L102.675 162.886C102.119 162.738 101.526 162.985 101.254 163.504L98.7822 168.188C98.5103 168.707 97.9171 168.954 97.361 168.806L92.2693 167.41C91.7131 167.261 91.1199 167.508 90.848 168.027L88.4381 172.625C88.1662 173.156 87.5483 173.403 86.9798 173.23L82.4442 171.834C81.851 171.55 81.3566 171.031 81.0847 170.388L71.0496 147.24",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3832 148.006L52.9813 105.567C51.35 101.81 53.0802 97.4474 56.8372 95.816L94.7162 79.3915C98.4733 77.7601 102.836 79.4903 104.467 83.2473L123.907 128.06",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1353 144.447L113.687 130.766",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1765 153.222L117.728 139.541",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7727 116.789L84.4711 118.445L80.1456 124.13",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8026 109.275L91.2063 114.848L98.4361 115.17",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5927 121.028C94.5927 121.028 93.4063 126.231 87.9685 124.364",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.754 105.765C146.512 105.765 148.747 103.529 148.747 100.772C148.747 98.0144 146.512 95.7791 143.754 95.7791C140.997 95.7791 138.761 98.0144 138.761 100.772C138.761 103.529 140.997 105.765 143.754 105.765Z",
    fill: "#6895F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.628 105.765C167.386 105.765 169.621 103.529 169.621 100.772C169.621 98.0144 167.386 95.7791 164.628 95.7791C161.871 95.7791 159.635 98.0144 159.635 100.772C159.635 103.529 161.871 105.765 164.628 105.765Z",
    fill: "#6895F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M148.673 120.422C148.673 120.422 154.173 112.414 162.144 119.224",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M159.635 81.604C159.635 81.604 161.316 85.0768 166.161 85.8059",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.823 81.604C149.823 81.604 148.142 85.0768 143.298 85.8059",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.4fa59b945163a03cce63b9ecdf09b55b.svg";
export { ForwardRef as ReactComponent };